import { useEffect, useState } from 'react'
import useAxios from '../../hooks/useAxios'
import { ICategory } from '../../types/category'
import { PaginationResponseInterface } from '../../types/pagination'
import SelectSearchMultiple, { IOptionSelect } from '../SelectSearchMultiple'
import SelectSearch from '.'

interface Props {
  categories?: string[]
  label?: string
  onSelect: (e: any) => void
  resetAutoComplete?: string
  multiple?: boolean
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  helperText?: string | any
  error?: boolean | any
  name?: string
  defaultValue?: any
}

const CategorySelectSearch = (props: Props) => {
  const {
    categories,
    label = 'เลือกหมวดหมู่สินค้า',
    onSelect,
    resetAutoComplete = '',
    multiple = true,
    ...rest
  } = props

  const [searchCategory, setSearchCategory] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [debouncedSearchProduct, setDebouncedSearchProduct] =
    useState<string>(searchCategory)

  const { data, isLoading } = useAxios<PaginationResponseInterface<ICategory>>({
    method: 'GET',
    url: '/category',
    params: {
      page: 1,
      perPage: 15,
      search: debouncedSearchProduct,
      startDate: '',
      endDate: '',
    },
  })

  useEffect(() => {
    setLoading(true)
    const handler = setTimeout(() => {
      setDebouncedSearchProduct(searchCategory)
      setLoading(false)
    }, 1000)

    return () => {
      clearTimeout(handler)
      setLoading(false)
    }
  }, [searchCategory])

  const handleSearchCategory = async (value: string) => {
    setSearchCategory(value)
  }

  const currentLoadingState = loading || isLoading

  return (
    <>
      {multiple ? (
        <SelectSearchMultiple<ICategory>
          resetAutoComplete={resetAutoComplete}
          placeholder={label}
          label={`${label} ${currentLoadingState ? 'กำลังโหลด...' : ''}`}
          onSelect={onSelect}
          search={searchCategory}
          onSearch={handleSearchCategory}
          options={
            data?.records
              .filter(
                (category: ICategory) => !categories?.includes(category.name),
              )
              .map(
                (category: ICategory) =>
                  category.isAvailable && {
                    label: category.name,
                    value: category,
                  },
              )
              .reduce((acc: IOptionSelect<ICategory>[], category) => {
                if (category) {
                  acc.push(category)
                }
                return acc
              }, []) || ([] as IOptionSelect<ICategory>[])
          }
        />
      ) : (
        <>
          <SelectSearch<any>
            {...rest}
            label={`${label} ${currentLoadingState ? 'กำลังโหลด...' : ''}`}
            onSelect={onSelect}
            search={searchCategory}
            onSearch={handleSearchCategory}
            options={
              data?.records
                .map(
                  (category: ICategory) =>
                    category.isAvailable && {
                      label: category.name,
                      value: category,
                    },
                )
                .reduce((acc: IOptionSelect<ICategory>[], category) => {
                  if (category) {
                    acc.push(category)
                  }
                  return acc
                }, []) || ([] as IOptionSelect<ICategory>[])
            }
          />
        </>
      )}
    </>
  )
}

export default CategorySelectSearch
